import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * The support chat is now a surface on /livy and the thread queue is a tab under Livy admin, so
 * this route only exists to carry old links to the queue rather than dead-end them.
 */
export function LivySupportPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/livy/admin?tab=support', {
      replace: true
    });
  }, [navigate]);
  return null;
}